import { Icon } from "@zapier/zinnia-icons";
import styles from "./CurrentAccountIndicator.module.css";

interface CurrentAccountIndicatorProps {
  isCurrentAccount: boolean;
}

const CurrentAccountIndicator = ({
  isCurrentAccount,
}: CurrentAccountIndicatorProps) => {
  if (!isCurrentAccount) {
    return null;
  }

  return (
    <>
      <div className={styles.backgroundCss} />
      <div className={styles.foregroundCss} data-testid="current-account-icon">
        <Icon
          aria-label="Current account"
          color="PrimeWhite"
          name="formCheck"
          size={32}
        />
      </div>
    </>
  );
};

export default CurrentAccountIndicator;
